// extracted by mini-css-extract-plugin
module.exports = {"bubble":"notificationsBubble-module_bubble_2XHXl"};